"use client";

import { useEffect } from "react";

export const messengerBannerHeightVar = "--messenger-banner-height";

// Inline-top Messenger banners push the page via body margin-top, which a fixed header ignores.
export const MessengerBannerOffset = () => {
  useEffect(() => {
    const { body, documentElement } = document;

    const sync = () => {
      const offset = parseFloat(body.style.marginTop) || 0;
      documentElement.style.setProperty(
        messengerBannerHeightVar,
        `${offset}px`,
      );
    };

    sync();
    const observer = new MutationObserver(sync);
    observer.observe(body, { attributes: true, attributeFilter: ["style"] });

    return () => {
      observer.disconnect();
      documentElement.style.removeProperty(messengerBannerHeightVar);
    };
  }, []);

  return null;
};
